import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserSettingsService } from '@/api/service-index';
import { UserSettingsDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/user-settings-display-model';
import { GetUserSettingsResponse } from '@/api/model-index';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsResolver implements Resolve<UserSettingsDisplayModel | undefined> {

  userSettings: UserSettingsDisplayModel | undefined;

  constructor(protected userSettingsService: UserSettingsService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserSettingsDisplayModel | undefined> {
    if (!this.userSettings) {
      return this.userSettingsService.apiUserSettingsGet().pipe(map((response: GetUserSettingsResponse) => {
        this.userSettings = response.userSettings;
        return response.userSettings;
      }));
    }
    return of(this.userSettings);
  }
}


